/** @prettier */
import classNames from 'classnames';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import ExternalLink from '../widgets/ExternalLink';

import styles from './ClientRedirect.module.scss';
import { getClientDomainByUrl } from './utils';

const ClientRedirect = ({ extraData }) => {
  const redirect = extraData.get('redirect');
  const domain = getClientDomainByUrl(redirect);

  const showSecondTextLine = redirect && !redirect.includes('matchbook');

  const imageClass = classNames({
    [styles.image]: true,
    [styles.matchbookmx]: redirect && redirect.includes('matchbook.mx'),
    [styles.easy]: redirect && redirect.includes('easy'),
  });

  return (
    <div className={styles.main}>
      <div className={imageClass} />
      <div className={styles.content}>
        <div className={styles.title}>
          {redirect.includes('easy')
            ? 'Are you an easyBet customer?'
            : `Are you a Matchbook${redirect && redirect.includes('mx') ? '.MX' : '.com'} customer?`}
        </div>
        <br />
        <div className={styles.description}>
          <p>
            {`It looks like you may already have an account on ${domain}.
            Due to licensing rules, ${redirect && redirect.includes('easy') ? 'easyBet' : `Matchbook${redirect && redirect.includes('mx') ? '.MX' : '.com'}`} customers are not permitted to play on Matchbook${redirect.includes('matchbook') ? '.com' : ''}.`}
          </p>
          {showSecondTextLine ? (
            <p>
              Don&apos;t worry though, both Matchbook and easyBet share the same markets, liquidity,
              and great odds, so you will not be missing out.
            </p>
          ) : (
            <p className={styles.spacer} />
          )}
        </div>
        <div className={styles.actions}>
          <ExternalLink href={redirect} notBlank>
            <Button sizeType="wider" buttonType="primary">
              Go to&nbsp;{domain}
            </Button>
          </ExternalLink>
        </div>
      </div>
    </div>
  );
};

ClientRedirect.propTypes = {
  // extraData: PropTypes.shape({
  //   redirect: PropTypes.string.isRequired,
  //   type: PropTypes.string.isRequired,
  // }),
  extraData: PropTypes.instanceOf(Map),
};

export default ClientRedirect;
